export const connections = [
    {
        id: 1,
        img: '/images/avatars/1.png',
        username: 'لیونل مسی',
        job: 'توسعه دهنده',
        skills: [
            'توییتر',
            'XD',
        ],
        projects: 54,
        tasks: 87,
        connections: 133,
        isConnected: false
    },
    {
        id: 2,
        img: '/images/avatars/2.png',
        username: 'جان اسنو',
        job: 'توسعه دهنده',
        skills: [
            'REACT',
            'VUE.JS',
        ],
        projects: 54,
        tasks: 87,
        connections: 133,
        isConnected: false
    },
    {
        id: 3,
        img: '/images/avatars/4.png',
        username: 'املیا کلارک',
        job: 'طراح',
        skills: [
            'فیگما',
            'فتوشاپ',
        ],
        projects: 75,
        tasks: 145,
        connections: 245,
        isConnected: true
    },
    {
        id: 4,
        img: '/images/avatars/9.png',
        username: 'پیتر پارکر',
        job: 'توسعه دهنده',
        skills: [
            'HTML',
            'CSS',
        ],
        projects: 43,
        tasks: 345,
        connections: 432,
        isConnected: true
    },
    {
        id: 5,
        img: '/images/avatars/12.png',
        username: 'بیل گیتس',
        job: 'توسعه دهنده نرم افزار',
        skills: [
            'C#',
            'SQL',
        ],
        projects: 233,
        tasks: 324,
        connections: 543,
        isConnected: false
    },
    {
        id: 6,
        img: '/images/avatars/14.png',
        username: 'دیوید بکام',
        job: 'طراح Ui',
        skills: [
            'XD',
            'SKETCH',
        ],
        projects: 34,
        tasks: 54,
        connections: 354,
        isConnected: true
    },
]